const MedicalPlanConsentStatus = Object.freeze({
  Draff: 1,
  Pending: 2,
  Signed: 3,
  Canceled: 4,
  Refused: 5,
});

export default MedicalPlanConsentStatus;
